import * as React from 'react';
import * as _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { colors, combineStyles, fonts, media, mixins } from 'consumer-components';
import { BlIcon } from 'shared-react';
import { constants, inputFormatters } from 'ui-common';

import * as deploymentConfig from 'login-utils/deploymentConfig';
import { leftRightContentPadding } from './LoanOfficerSharedStyles';
import { paneDefaultStyles } from 'login-components/Common/PaneLayout/paneStyles';
import { loginBackgroundDynamicColor } from 'login-stylesheets/deploymentColors';

const loPortraitDimension = 70;
const loPortraitMargin = 16;

const ownStyles = StyleSheet.create({
  description: {
    whiteSpace: 'pre-line',
  },
  wrapper: {
    ...fonts.Roboto,
    color: loginBackgroundDynamicColor,
    pointerEvents: 'auto',
  },
  loNmls: {
    paddingTop: 5,
  },
  loPadding: mixins.padding(0, leftRightContentPadding, 20),
  loPortrait: combineStyles(mixins.border(2, 'solid', mixins.fade(colors.white, 0.8)), {
    borderRadius: '100%',
    height: loPortraitDimension,
    marginRight: loPortraitMargin,
    width: loPortraitDimension,
  }),
  loText: {
    display: 'inline-block',
    maxWidth: `calc(100% - ${loPortraitDimension + loPortraitMargin}px)`,
  },
  iconStyling: {
    color: mixins.fade(loginBackgroundDynamicColor, 0.9),
    paddingLeft: 5,
  },
  infoWrapper: {
    ...mixins.borderBottom(1, 'solid', mixins.fade(loginBackgroundDynamicColor, 0.7)),
    ...mixins.margin(0, leftRightContentPadding),
    ...mixins.padding(15, 0),
    display: 'flex',
    ':last-child': {
      border: 'none',
    },
  },
  info: {
    color: 'inherit',
    marginLeft: 20,
    position: 'relative',
    top: -2,
    wordBreak: 'break-word',
  },
  nameAvatarWrapper: {
    display: 'flex',
  },
  phoneNumber: {
    textDecoration: 'none',
  },
  title: {
    wordBreak: 'break-word',
    fontSize: 30,
    [media.smallView]: {
      fontSize: 24,
    },
  },
});

export interface OwnProps {
  avatar?: string;
  email?: string;
  phoneExtension?: string;
  phoneNumber?: number;
  fullName: string;
  nmlsId: string;
}

export default class LoanOfficerLeftPaneBody extends React.Component<OwnProps> {
  render() {
    const {
      avatar,
      fullName,
      email,
      phoneExtension: loPhoneExtension,
      phoneNumber: loPhoneNumber,
      nmlsId,
    } = this.props;
    const avatarImgSrc = constants.imageConstants.UserSettingsImageConstants.FILE_URL + avatar;
    const phoneNumber = loPhoneNumber ? loPhoneNumber.toString() : deploymentConfig.get().organization.supportPhone;

    return (
      <div className={css(ownStyles.wrapper)}>
        <div className={css(ownStyles.loPadding, ownStyles.nameAvatarWrapper)}>
          {avatar && (
            <div>
              <img className={css(ownStyles.loPortrait)} src={avatarImgSrc} />
            </div>
          )}
          <div className={css(ownStyles.loText)}>
            <h1 className={css(paneDefaultStyles.title, ownStyles.title)}>{fullName}</h1>
            <h2 className={css(ownStyles.loNmls)}>NMLS #{nmlsId}</h2>
          </div>
        </div>
        {_.get(deploymentConfig.get(), 'loanOfficerPages.loanOfficerDescription') && (
          <p className={css(ownStyles.loPadding, ownStyles.description)}>
            {_.get(deploymentConfig.get(), 'loanOfficerPages.loanOfficerDescription')}
          </p>
        )}
        <div className={css(ownStyles.infoWrapper)}>
          <div className={css(ownStyles.iconStyling)}>
            <BlIcon icon="email" size="md" />
          </div>
          <a href={`mailto:${email}`} className={css(ownStyles.info)}>
            {email}
          </a>
        </div>
        {phoneNumber && (
          <div className={css(ownStyles.infoWrapper)}>
            <div className={css(ownStyles.iconStyling)}>
              <BlIcon icon="phone2" size="md" />
            </div>
            <a
              href={`tel:${phoneNumber}${loPhoneNumber && loPhoneExtension ? `;${loPhoneExtension}` : ''}`}
              className={css(ownStyles.info, ownStyles.phoneNumber)}
            >
              {`${inputFormatters.PHONE.format(phoneNumber)}${
                loPhoneNumber && loPhoneExtension ? ` x ${loPhoneExtension}` : ''
              }`}
            </a>
          </div>
        )}
      </div>
    );
  }
}
